import { ActionTree, GetterTree, MutationTree } from "vuex";
import { action, createModule, mutation } from "vuex-class-component";
import { Module } from "vuex";
import { RootStore } from "../types";

const VuexModule = createModule({
  strict: false,
  namespaced: "ux",
});

export class Ux extends VuexModule {
  /* State */
  ready = false
  reserveSpaceForDrawer = false;
  documentAiAnalysisConfirmed = false;
  /* Snackbar */
  snackbar = false;
  pending = false;
  success = false;
  failure = false;
  sbcontext = "info";
  sbtext = "";
  sbtimeout = 4000;
  /* Colors */
  darkTheme = false;
  // colorSuccess: "#64DD17",
  // colorInfo: "#039BE5",
  // colorWarning: "#F57C00",
  // colorError: "#F443364",
  // colorHeader1: "#FF9C10",
  // colorDivider1: "#FFC98A"
  colorSuccess = "white";
  colorInfo = "white";
  colorWarning = "white";
  colorError = "white";
  colorHeader1 = "#006064";
  colorDivider1 = "white";
  colorAccent = "#036065";
  colorAccent1 = "#036065";
  colorAccent2 = "#00B4A1";
  colorAccent3 = "#5B9FA1";
  colorAccent4 = "#99CCCC";
  colorAccent5 = "#99FFFF";
  colorAccent6 = "#4D4D4D";
  colorAccent7 = "#999999";
  colorAccent8 = "#cccccc";
  colorAccent9 = "#e05a1a";
  dcPurple = "#ae7fd4";
  dcPink = "#da178f";
  dcBlue = "#007aff";
  dcYellow = "#dad617";
  dcRed = "#ff0000";
  colorListBackground = "white";
  appBackground = "white";

  appVersion = "v1.3.04";
  buildDate = "18.08.2026";

  get isReady() {
    return this.ready
  }

  // user settings

  @action async setDocumentAiAnalysisConfirmed() {
    // window.sessionStorage.setItem('documentAiAnalysisConfirmed', 'true');
    this.SET_DOCUMENT_AI_ANALYSIS_CONFIRMED(true);
  }

  @action async clearDocumentAiAnalysisConfirmed() {
    // window.sessionStorage.removeItem('documentAiAnalysisConfirmed');
    this.SET_DOCUMENT_AI_ANALYSIS_CONFIRMED(false);
  }

  @mutation SET_DOCUMENT_AI_ANALYSIS_CONFIRMED(value: boolean) {
    this.documentAiAnalysisConfirmed = value;
  }

  get isDocumentAiAnalysisConfirmed() {
    return this.documentAiAnalysisConfirmed;
  }

  // @action async saveUserSettings(darkMode: boolean) {
  //   window.localStorage.setItem("darkMode", darkMode.toString());
  // }
  
  @action async restoreDarkMode() {
    const dm = window.localStorage.getItem('darkMode');
    if (!dm) {
      this.COLORS_LIGHT();
      return;
    }
      
    if (dm == "true")
      this.COLORS_DARK2();
    else
      this.COLORS_LIGHT();
  }

  // Customer
  get isL3online(): boolean {
    return true;
  }

  get isL3schreiner(): boolean {
    return false;
  }

  get isL3johannesbad(): boolean {
    return false;
  }

  get quizPlayerBackgroundGradient() {
    if (this.darkTheme)
      // return "background-image: linear-gradient(180deg, #616161 0%, #036065 50%);";
      return "background-image: linear-gradient(180deg, #424242 0%, #424242 50%);";

    // return "background-image: linear-gradient(180deg, #e1e1e1ff 0%, #a9f1f1ff 70%);";
    return "background-image: linear-gradient(180deg, #eeeeee 0%, #eeeeee 70%);";
  }

  get gradientText() {
    if (this.darkTheme)
      return "background: linear-gradient(90deg,rgb(70, 215, 218),rgb(100, 213, 224),rgb(182, 220, 235); -webkit-background-clip: text; -webkit-text-fill-color: transparent; ";

    return "background: linear-gradient(90deg,rgb(6, 64, 66),rgb(20, 123, 139),rgb(19, 164, 205)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; ";
  }

  get gradientBackground() {
    return "background: linear-gradient(110deg, #119a9d, #64c2ba);";
  }

  get gradientBackground1() {
    if (this.darkTheme)
      return "background: linear-gradient(120deg, #068d94 0%, #036065 50%)";

    return "background: linear-gradient(120deg,rgb(231, 231, 231),rgb(219, 251, 253));";
  }

  get gradientBackground2() {
    return "background: linear-gradient(90deg, #068d94 0%, #036065 50%);";
  }

  get gradientBackground3() {
    return "background: linear-gradient(90deg, #064042, #147b8b, #13a4cd);";
  }

  @mutation setReady() {
    this.ready = true
  }

  @mutation ReserveSpaceForDrawer(isVisible: boolean) {
    this.reserveSpaceForDrawer = isVisible;
  }

  /* Snackbar */
  @mutation SB_PENDING(state) {
    this.pending = true;
  }

  @mutation SB_SUCCESS(data: any) {
    this.failure = false;
    this.sbcontext = "success";
    this.success = true;
    this.sbtext = data.message;
    this.snackbar = true;
    this.pending = false;
    if (data.timeout) this.sbtimeout = data.timeout;
    else this.sbtimeout = 2000;
  }
  @mutation SB_PRIMARY(data) {
    this.failure = false;
    this.sbcontext = "primary";
    this.success = true;
    this.sbtext = data.message;
    this.snackbar = true;
    this.pending = false;
    if (data.timeout) this.sbtimeout = data.timeout;
    else this.sbtimeout = 2000;
  }
  @mutation SB_FAILURE(data) {
    this.success = false;
    this.sbcontext = "error";
    this.failure = true;
    this.sbtext = data.message;
    this.snackbar = true;
    this.pending = false;
    if (data.timeout) this.sbtimeout = data.timeout;
    else this.sbtimeout = 0;
  }
  @mutation SB_WARNING(data) {
    this.success = false;
    this.sbcontext = "deep-orange darken-2";
    this.failure = true;
    this.sbtext = data.message;
    this.snackbar = true;
    this.pending = false;
    if (data.timeout) this.sbtimeout = data.timeout;
    else this.sbtimeout = 15000;
  }
  @mutation SB_UPDATE(value) {
    this.snackbar = value;
  }

  /* Colors */
  @mutation COLORS_DARK1() {
    this.darkTheme = true;
    window.localStorage.setItem("darkMode", "true");

    this.colorSuccess = "#66BB6A";
    this.colorInfo = "#42A5F5";
    this.colorWarning = "#F57C00";
    this.colorError = "#F44336";
    this.colorHeader1 = "#FF9C10";
    this.colorDivider1 = "#FFC98A";
    this.colorAccent = "#FF9C10";
    this.colorListBackground = "#353535";
    this.appBackground = "#616161";
  }
  @mutation COLORS_DARK2() {
    this.darkTheme = true;
    window.localStorage.setItem("darkMode", "true");

    this.colorSuccess = "#11B59F";
    this.colorInfo = "#4E9DEC";
    this.colorWarning = "#F57C00";
    this.colorError = "#F44336";
    this.colorHeader1 = "#006064";
    this.colorDivider1 = "#FFFFFF";
    this.colorAccent = "#00B4A1";
    this.dcPurple = "#ae7fd4";
    this.dcPink = "#da178f";
    this.dcBlue = "#007aff";
    this.dcYellow = "#dad617";
    this.dcRed = "#ff0000";
    this.colorListBackground = "#353535";
    this.appBackground = "#616161";
  }
  @mutation COLORS_LIGHT() {
    this.darkTheme = false;
    window.localStorage.setItem("darkMode", "false");
    
    this.colorSuccess = "#66BB6A";
    this.colorInfo = "#42A5F5";
    this.colorWarning = "#F57C00";
    this.colorError = "#F44336";
    this.colorHeader1 = "#006064";
    this.colorAccent = "#036065";
    this.colorDivider1 = "#FFFFFF";
    this.dcPurple = "#ae7fd4";
    this.dcPink = "#da178f";
    this.dcBlue = "#007aff";
    this.dcYellow = "#cac725";
    this.dcRed = "#ff0000";
    this.colorListBackground = "#FFFFFF";
    // this.appBackground = "#BDBDBD";
    this.appBackground = "#FFFFFF";
  }
}
